import request from '@godaddy/request';
import debug from './utils/diagnostics';
import * as json from './utils/json';
const cookie = require('koekiemonster')();
import URL from './utils/url';
import { registerKeyboardNavListener } from './utils/register-keyboard-nav';

//
// @deprecated
// We have moved on from `cookie-monster` as it is no longer maintained
// Polyfill to cookie-monster@0.1.1
// See: https://github.com/kahnjw/cookie-monster/compare/0.1.1...0.2.1
//
cookie.get = cookie.getItem;
cookie.set = cookie.setItem;
cookie.remove = cookie.removeItem;
cookie.clear = null;

//
// @deprecated
// sessionStorage is now available on window in all browsers in our
// target support matrix. However, since it was previously exposed
// prior to this we must re-expose it in this fashion.
//
let storage;
if (typeof window !== 'undefined') {
  storage = window.sessionStorage;
}

export {
  registerKeyboardNavListener,
  request,
  storage,
  cookie,
  debug,
  json,
  URL
};
